import React from 'react';

import { StorageOfUniqueServices } from '@qality/common-service';

import { ProjectIssueTypesContext } from './ProjectIssueTypesContext';

export const ProjectIssueTypesProvider = ({ children }: { children: any }) => {
  const [projectKey, setProjectKey] = React.useState();
  const [projectIssueTypes, setProjectIssueTypes] = React.useState([]);

  const fetchIssueTypes = async (key) => {
    const issueTypes = await StorageOfUniqueServices.get(
      'QAlityIssueTypeService'
    ).getFields(key);
    setProjectKey(key);
    setProjectIssueTypes(issueTypes);
  };

  return (
    <ProjectIssueTypesContext.Provider
      value={{
        projectKey,
        projectIssueTypes,
        fetchIssueTypes,
      }}
    >
      {children}
    </ProjectIssueTypesContext.Provider>
  );
};
